module.exports = __webpack_public_path__ + "media/site_templates/www.waterleakrepair.com.au/images/our_services_3-39da2cb8dfee05d95fd233c228ae2402.jpg";